import { type GenericMap } from "@client/types";
import { type CreditCardInfoClasses } from "@common/controls/Inputs/CreditCard/component";
import { type I18n } from "@common/lib/i18n";
import { isUndefined } from "lodash";
import { type CollectJs } from "./types";

export const adjustHeightValue = (lineHeight: string | number | undefined): string | undefined => {
  if (isUndefined(lineHeight)) return;
  if (typeof lineHeight === "string" && isNaN(+lineHeight)) return lineHeight;

  return `${lineHeight}em`;
};

export const init = async (tokenizationKey: string): Promise<CollectJs> => {
  const key = `nmi-${tokenizationKey}`;
  if (!window[key]) {
    window[key] = new Promise<CollectJs>((resolve) => {
      const script = document.createElement("script");

      script.src = "https://secure.networkmerchants.com/token/Collect.js";
      script.dataset.tokenizationKey = tokenizationKey;
      script.async = true;
      script.onload = () => {
        resolve(window["CollectJS"] as CollectJs);
      };

      document.body.appendChild(script);
    });
  }
  return window[key];
};

export const INPUT_CLASSES: CreditCardInfoClasses = {
  cvv: "cvc",
  date: "date",
  number: "number"
};

export const getError = (i18n: I18n, validations: GenericMap<string | null>): string | null => {
  if (!Object.keys(validations).length) return i18n.errorRequiredField;

  const errorKey = Object.keys(validations).find((x) => validations[x]);
  if (errorKey) return validations[errorKey];

  if (!("ccnumber" in validations)) return i18n.errorCardNumberRequired;
  if (!("ccexp" in validations)) return i18n.errorCardExpirationDateRequired;
  if (!("cvv" in validations)) return i18n.errorCardCVVRequired;

  return null;
};
